import { useTranslation } from "react-i18next";
import * as Yup from "yup";

export function usePointSourceSchema() {
  const { t } = useTranslation();

  const schema = Yup.object().shape({
    emissions_kg_h: Yup.array().of(
      Yup.object().shape({
        emission_kg_h: Yup.number().required(
          t("label.isRequiredValidation", {
            field: t("label.thisField"),
          })
        ),
      })
    ),
    nonox: Yup.number().required(
      t("label.isRequiredValidation", {
        field: t("label.NOOverNOXRatio"),
      })
    ),
    height_m: Yup.number().required(
      t("label.isRequiredValidation", {
        field: t("label.height"),
      })
    ),
    flowrate_Nm3_s: Yup.number().required(
      t("label.isRequiredValidation", {
        field: t("label.flowrate"),
      })
    ),
    diameter_m: Yup.number().required(
      t("label.isRequiredValidation", {
        field: t("label.diameter"),
      })
    ),
    temperature_K: Yup.number().required(
      t("label.isRequiredValidation", {
        field: t("label.temperature"),
      })
    ),
    ifdmTimeFactor: Yup.string().required(
      t("label.isRequiredValidation", {
        field: t("label.timefactor"),
      })
    ),
  });
  return schema;
}
